import React, { useContext, useState } from 'react';

import { ApiRoutes, FetchContext, HttpMethods, ToastContext } from '../../contexts';

import { useAggregatedState } from '../../../helpers';
import { ApiDomains } from '../../contexts/FetchContext';

export const TipoUfficioContext = React.createContext(null);

const { Provider } = TipoUfficioContext;

export const TipoUfficioProvider = (props) => {
    const {
        showWarningMessage,
        showSuccessMessage,
        showErrorMessage
    } = useContext(ToastContext);
    const { fetchOk, fetchAuthorized } = useContext(FetchContext);
    const [state, setState] = useAggregatedState({
        tipo: null,
        tipi: null,
        iconFiles: [],

        competenze: null,
        competenzeOptions: [],
    });

    const { tipi, iconFiles } = state;

    const [isLoadingTipo, setIsLoadingTipo] = useState(false);
    const getTipoAsync = async (tipoUfficioId) => {
        try {
            setIsLoadingTipo(true);
            const r = await fetchAuthorized(ApiRoutes.TipoUfficio.GetTipoUfficio({ tipoUfficioId }), {
                method: HttpMethods.GET
            });
            const result = await r.json();
            result.inizioValidita = new Date(result.inizioValidita);
            result.fineValidita = result.fineValidita ? new Date(result.fineValidita) : null;
            setState({ tipo: result });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingTipo(false);
        }
    }

    const [isLoadingTipi, setIsLoadingTipi] = useState(false);
    const getTipiAsync = async (pageIndex = 0, pageSize = 100, padreId = null) => {
        try {
            setIsLoadingTipi(true);
            const r = await fetchAuthorized(ApiRoutes.TipoUfficio.GetTipiUffici({ pageIndex, pageSize, padreId }), {
                method: HttpMethods.GET
            });
            const list = await r.json();
            list.result = list.result.map(e => {
                return {
                    ...e,
                    inizioValidita: new Date(e.inizioValidita),
                    fineValidita: e.fineValidita ? new Date(e.fineValidita) : null,
                }
            });
            setState({ tipi: list });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingTipi(false);
        }
    }

    const [isUpdatingTipo, setIsUpdatingTipo] = useState(false);
    const updateTipoAsync = async (tipoUfficioId, tipo) => {
        try {
            setIsUpdatingTipo(true);
            const r = await fetchAuthorized(ApiRoutes.TipoUfficio.UpdateTipoUfficio({ tipoUfficioId }), {
                method: HttpMethods.POST,
                body: JSON.stringify(tipo),
            });
            const result = await r.json();
            setState({
                tipo: {
                    ...result,
                    inizioValidita: new Date(result.inizioValidita),
                    fineValidita: result.fineValidita ? new Date(result.fineValidita) : null
                }
            });
            showSuccessMessage("Tipo aggiornato");
            window.close();
        } catch (e) {
            console.debug(e);
        } finally {
            setIsUpdatingTipo(false);
        }
    }

    const [isAddingTipo, setIsAddingTipo] = useState(false);
    const addTipoAsync = async (tipo) => {
        try {
            setIsAddingTipo(true);
            const r = await fetchAuthorized(ApiRoutes.TipoUfficio.AddTipoUfficio(), {
                method: HttpMethods.PUT,
                body: JSON.stringify(tipo),
            });
            const result = await r.json();
            setState({
                tipo: {
                    ...result,
                    inizioValidita: new Date(result.inizioValidita),
                    fineValidita: result.fineValidita ? new Date(result.fineValidita) : null
                }
            });
            showSuccessMessage("Tipo creato");
            window.close();
        } catch (e) {
            console.debug(e);
        } finally {
            setIsAddingTipo(false);
        }
    }

    const [isDeletingTipo, setIsDeletingTipo] = useState(false);
    const deleteTipoAsync = async (tipoUfficioId,) => {
        try {
            setIsDeletingTipo(true);
            const r = await fetchAuthorized(ApiRoutes.TipoUfficio.DeleteTipoUfficio({ tipoUfficioId }), {
                method: HttpMethods.DELETE
            });
            showSuccessMessage(`Tipo con id ${tipoUfficioId} disabilitato`);
        } catch (e) {
            console.debug(e);
        } finally {
            setIsDeletingTipo(false);
        }
    }

    const [isAddingFile, setIsAddingFile] = useState(false);
    const addFileAsync = async (file) => {
        try {
            setIsAddingFile(true);

            var formData = new FormData();
            formData.append("formFile", file);

            const r = await fetchAuthorized(ApiRoutes.File.AddFile(), {
                method: HttpMethods.PUT,
                body: formData,
            });
            const result = await r.json();
            getFilesAsync(0, 1000);
            showSuccessMessage("File caricato");
        } catch (e) {
            console.debug(e);
        } finally {
            setIsAddingFile(false);
        }
    }

    const [isLoadingFiles, setIsLoadingFiles] = useState(false);
    const getFilesAsync = async (pageIndex = 0, pageSize = 100, contentType = "image") => {
        try {
            setIsLoadingFiles(true);
            const r = await fetchAuthorized(ApiRoutes.File.GetFiles({ pageIndex, pageSize, contentType }), {
                method: HttpMethods.GET
            });
            const list = await r.json();
            setState({ iconFiles: list.result.map(e => `${ApiDomains.GiustiziaMap}/File/${e.id}`) });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingFiles(false);
        }
    }

    return (
        <Provider value={{
            state,
            setState,

            isLoadingTipo,
            getTipoAsync,

            isLoadingTipi,
            getTipiAsync,

            isUpdatingTipo,
            updateTipoAsync,

            isAddingTipo,
            addTipoAsync,

            isDeletingTipo,
            deleteTipoAsync,

            isAddingFile,
            addFileAsync,

            isLoadingFiles,
            getFilesAsync,
        }}>
            {props.children}
        </Provider>
    );
}